import { defineCustomElement } from '@tyler-components-web/core';
import { ScaffoldComponent } from './scaffold';
export * from './scaffold-constants';
export * from './scaffold';
export function defineScaffoldComponent() {
    defineCustomElement(ScaffoldComponent);
}
